import styled from "styled-components"; 


export const ValidaTurnoCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: var(--color-latex30);
  color: var(--color-white);
  height: 64px;
  position: relative;
  div {
    display: flex;
    flex-direction: column;
}
.resumencard-corazonIcon{
  z-index:10;
}
.text {
    width: 190px;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 155%;
    z-index:10;
  }
.number {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    z-index:10;
}

::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 20px;
        left: 0;
        bottom: -10px;
        z-index: -10;
        border-radius: 50%;
        background-color: var(--color-latex30);
    }
`;